import { init, registerRemotes } from '@module-federation/enhanced/runtime';
import { retryPlugin, fallbackPlugin } from '../plugins/remotePlugins';
import {
  localImportMaps,
  defaultMfes,
  membershipMfes,
  MEMBERSHIP_ROUTE,
} from '../server/serverConstants';
import {
  isValidStaticMfePath,
  PLP_PATHS,
  checkSlug,
  isValidMembershipPath,
  MFE_ROUTES,
  COMMON_MFES,
} from './routeUtils';

export async function getImportMaps({ DEV_MODE = 'false', IMPORT_MAP_URL = '' } = {}) {
  try {
    if (DEV_MODE === 'true') {
      return localImportMaps.imports;
    }
    const resp = await fetch(IMPORT_MAP_URL);
    const data = await resp.json();
    console.log('remote importmaps:', data);
    return data.imports || {};
  } catch (error) {
    console.error('Error fetching entry URL:', error);
  }
}

function getRemoteMfePath(maps = {}, mfeName = '', isServer = false) {
  const baseUrl = maps[mfeName];
  if (!baseUrl) return null;
  const url = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const type = isServer ? 'server' : 'client';
  return `${url}${type}/remoteEntry.js`;
}

function generateRemotes(mfeNames: string[] = [], importMaps = {}, isServer = false) {
  return mfeNames.reduce(
    (acc, name) => {
      const entry = getRemoteMfePath(importMaps, name, isServer);
      if (entry) acc.push({ name, entry });
      return acc;
    },
    [] as { name: string; entry: string }[],
  );
}

export function initRemoteMfes(importMaps = {}, isServer = false, pageRoute = '') {
  const mfeList = pageRoute?.toLowerCase()?.startsWith(MEMBERSHIP_ROUTE)
    ? membershipMfes
    : defaultMfes;
  const remotes = generateRemotes(mfeList, importMaps, isServer);
  console.log('remotes', remotes);
  init({
    name: 'rootMfe',
    remotes,
    plugins: [retryPlugin(), fallbackPlugin()],
  });
}

const getRouteSpecificPreloadMfes = (req: any) => {
  const { path, query } = req || {};
  const isShopAll = query?.shopall?.toLowerCase() === 'y';
  const currentRoute = path?.split('/')[1] || '';
  const mfes = [...COMMON_MFES];
  if (checkSlug(PLP_PATHS, currentRoute, isShopAll)) {
    mfes.push(MFE_ROUTES.search);
  } else if (isValidMembershipPath(currentRoute?.toLowerCase())) {
    mfes.push(MFE_ROUTES.membership);
  } else if (MFE_ROUTES[currentRoute]) {
    mfes.push(MFE_ROUTES[currentRoute]);
  } else if (isValidStaticMfePath(currentRoute, isShopAll)) {
    mfes.push(MFE_ROUTES.staticRoute);
  }
  return mfes;
};

export function getPreloadScripts(importMaps, req): string {
  const mfes = getRouteSpecificPreloadMfes(req);

  return mfes
    .reduce((acc, mfe) => {
      const path = getRemoteMfePath(importMaps, mfe);
      if (path) acc.push(`<link rel="preload" href="${path}" as="script" fetchpriority="high">`);
      return acc;
    }, [] as string[])
    .join('\n');
}
